import instance, { ADMIN_PREFIX } from 'services/api';
import { UpdateMeSettingsResponse } from 'types/api/profile';

/**
 * PUT /api/v2/admin/auth/me/settings (cycle-28) — full-replace write
 * on the calling admin's user.settings jsonb. JWT-scoped; the FE
 * always ships the merged settings object so the BE writes verbatim.
 * Returns { status, settings }; FE refetches /auth/me afterward.
 */
export const updateMeSettings = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings: Record<string, any>
): Promise<UpdateMeSettingsResponse> => {
  const res = await instance.put<UpdateMeSettingsResponse>(
    `${ADMIN_PREFIX}/auth/me/settings`,
    { settings }
  );

  return res.data;
};
